import React, { useContext, useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import { MyContext } from '../../Context/MyProvider';
import PageLoading from '../PageLoading';

const Pages = () => {

    const { HandleCallApi } = useContext(MyContext);

    const [loading, setLoading] = useState(true);
    const [pageList, setPageList] = useState([]);

    const PageListRef = useRef(false);
    const Params = useParams();
    const Title = Params.title?.replaceAll('-', ' ');

    useEffect(() => {
        handleGetPageList();
    }, []);

    const handleGetPageList = async () => {
        if (PageListRef.current) return;
        PageListRef.current = true;

        const Response = await HandleCallApi("Get", "user/pages");
        setPageList(Response.data.pages_data);
        setLoading(false);
    }

    return (
        <div className='py-5'>
            <div className='width_container'>
                {pageList?.length >= 1 &&
                    pageList?.map((item, index) => {
                        if (item.title.toLowerCase() === Title.toLowerCase()) {
                            return (
                                <div key={index}>
                                    <h3 className='text-[20px] font-[500]'>{item.title}</h3>
                                    <p className='p-[20px]' dangerouslySetInnerHTML={{ __html: item?.description }} />
                                </div>
                            );
                        }
                        return null;
                    })
                }
            </div>

            <PageLoading loading={loading} />

        </div>
    )
}

export default Pages